import store from "../shop/store";
import { renderStates, renderCountries } from "../shop/templates/partials";
import { getCookie, setCookie } from "../util/dom";
import { changeAddressInput, changeCountry, bulkChangeQuantity, updateKlarna, updateGlobalECountry } from "../shop/connect";
import { getIpInfo } from "./ipgeolocation";
import { trackRemoveFromCart } from "./stoked";
import { updateGlobalECountryMethod } from "./global-e";
var pfasCountries = window.sitewide.pfasLocationSettings || {};
var geolocationCountries = window.sitewide.geolocationSettings || {};
var config = {
  wrapper: "#js-pfas",
  country: ".js-country",
  countryText: ".js-country-text",
  state: ".js-state",
  stateText: ".js-state-text",
  currentStateText: ".js-current-state",
  submit: ".js-pfasContinue",
  classes: {
    loading: "is-loading",
    active: "active"
  },
  cookieName: "pfas_data",
  cookieOriginName: "pfas_origin_path",
  cookieExpiryDays: 3652 // 10 years
};
var redirectPage = window.sitewide.pfasHomeURL || "";
var geoLocationPage = window.sitewide.geoLocationPage || "";
var countries = {};
var currentCountry = "";
var states = "";
var onPageLoad = false;
var pfasInit = function pfasInit() {
  var wrapper = $(config.wrapper);
  if (wrapper.length === 0) {
    return;
  }
  var _store$getState = store.getState(),
    escCountries = _store$getState.countries,
    escStore = _store$getState.store;
  states = getStates();
  currentCountry = escStore.country;
  onPageLoad = true;
  countries = escCountries;
  setRedirectPageFromCookie();
  renderFormCountries(wrapper);
  renderFormState(wrapper);
  initializedEvent(wrapper);
};
var handleGeoBasedRedirect = function handleGeoBasedRedirect(country) {
  var redirectPage = "";
  if (!getCookieData() && country && geolocationCountries[country]) {
    redirectPage = determineRedirectPage();
  }
  if (redirectPage) {
    window.location.href = redirectPage;
  }
};
var determineRedirectPage = function determineRedirectPage() {
  var currentUrl = window.location.origin + window.location.pathname;
  var originalPath = window.location.href;
  if (geoLocationPage.trim() === currentUrl.trim()) {
    return null;
  }
  setOriginPathCookie(originalPath);
  return geoLocationPage;
};
var removePfasProductFromCart = function removePfasProductFromCart() {
  if (!getCookieData('banEnabled')) return;
  var _store$getState2 = store.getState(),
    selection = _store$getState2.selection,
    productCache = _store$getState2.productCache;
  var pfasProductCartLines = selection.items.filter(function (item) {
    var productId = item.item.split('-')[0];
    var productData = productCache.items[productId] || {};
    if (!productData.isPfasProduct) return false;
    $.event.trigger("stoked-remove-from-cart", [item.line, item.quantity, trackRemoveFromCart]);
    return true;
  }).map(function (item) {
    return {
      line: item.line,
      quantity: 0
    };
  });
  if (pfasProductCartLines.length === 0) return;
  bulkChangeQuantity(pfasProductCartLines).then(function () {});
};
var setRedirectPageFromCookie = function setRedirectPageFromCookie() {
  var originPath = getCookie(config.cookieOriginName) || "";
  if (originPath) {
    redirectPage = decodeURIComponent(originPath);
  }
};
var initializedEvent = function initializedEvent(wrapper) {
  // Select state
  wrapper.on("click", ".dropdown-item", function (e) {
    e.preventDefault();
    onPageLoad = false;
    var selectedValue = $(e.currentTarget).data("value") || "";
    var btn = wrapper.find(config.submit);
    var fieldType = $(e.currentTarget).parent().data("name") || "state";
    if (btn.length) {
      btn.prop("disabled", !selectedValue);
    }
    wrapper.find("[data-name=\"".concat(fieldType, "\"] .dropdown-item")).removeClass(config.classes.active);
    $(e.currentTarget).addClass(config.classes.active);
    updateFormDropdownText(wrapper, selectedValue, fieldType);
    if (fieldType === "country") {
      states = getStates(selectedValue);
      renderFormState(wrapper, selectedValue, true);
    }
  });

  // Submit state selection
  wrapper.on("click", config.submit, function (e) {
    e.preventDefault();
    var _this = $(e.currentTarget);
    var selectedCountry = _this.parent().find(".js-country .dropdown-item.active").data("value") || "";
    var selectedState = _this.parent().find(".js-state .dropdown-item.active").data("value") || "";
    _this.addClass(config.classes.loading);
    setTimeout(function () {
      processFormSubmit(_this, selectedCountry, selectedState);
    }, 1000);
  });
};
var processFormSubmit = function processFormSubmit(currentEl, selectedCountry, selectedState) {
  currentEl.removeClass(config.classes.loading);
  var pfasCountryStates = pfasCountries[selectedCountry] || [];
  var isPfasCountryWithoutState = pfasCountryStates.length === 0 && pfasCountries.hasOwnProperty(selectedCountry);
  var isBanEnabled = pfasCountryStates.includes(selectedState) || isPfasCountryWithoutState;
  changeCountry(selectedCountry).then(function () {
    updateGlobalECountryMethod(false).then(function () {
      changeAddressInput("address", "state", selectedState);
      updatePfasCookie({
        selectedState: selectedState,
        isBanEnabled: isBanEnabled,
        country: selectedCountry
      });
    }).catch(function (error) {
      console.error('Error updating Global E country:', error);
    });
  });
};
var handleCountryChange = function handleCountryChange(country) {
  updateGlobalECountryMethod(false).then(function () {
    var isBanEnabled = pfasCountries.hasOwnProperty(country) === true;
    var hasPfasState = isBanEnabled && pfasCountries[country] && pfasCountries[country].length > 0;
    var forceDeleteCookie = geolocationCountries.hasOwnProperty(country) && hasPfasState;
    if (hasPfasState || forceDeleteCookie) {
      deleteCookieData(config.cookieOriginName);
      deleteCookieData(config.cookieName);
      location.reload();
      return;
    }
    redirectPage = window.location.href;
    updatePfasCookie({
      isBanEnabled: isBanEnabled,
      selectedState: "",
      country: country
    });
  }).catch(function (error) {
    console.error('Error updating Global E country:', error);
  });
};
var updatePfasCookie = function updatePfasCookie(_ref) {
  var selectedState = _ref.selectedState,
    isBanEnabled = _ref.isBanEnabled,
    country = _ref.country;
  var cookieCountry = country || currentCountry;
  updateCookieData({
    country: cookieCountry,
    state: selectedState,
    banEnabled: isBanEnabled
  });
  if (!redirectPage) {
    return;
  }
  if (redirectPage.replace(/\/$/, "") !== window.location.href.replace(/\/$/, "")) {
    deleteCookieData(config.cookieOriginName);
    window.location.href = decodeURI(redirectPage);
    return;
  }
  location.reload();
};
var deleteCookieData = function deleteCookieData() {
  var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : config.cookieName;
  setCookie(cookieName, "", config.cookieExpiryDays * -1, getCookiePath());
};
var getCookieData = function getCookieData() {
  var returnItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var data = JSON.parse(decodeURIComponent(getCookie(config.cookieName)) || "{}");
  if (returnItem) {
    return data && data[returnItem] ? data[returnItem] : null;
  }
  return data;
};
var getCookiePath = function getCookiePath() {
  return window.location.protocol.indexOf('https:') !== -1 ? "SameSite=None; Secure" : "";
};
var setOriginPathCookie = function setOriginPathCookie(originalPath) {
  setCookie(config.cookieOriginName, originalPath, config.cookieExpiryDays, getCookiePath());
};
var updateCookieData = function updateCookieData(data) {
  setCookie(config.cookieName, JSON.stringify(data), config.cookieExpiryDays, getCookiePath());
};
var renderFormCountries = function renderFormCountries(wrapper) {
  var _store$getState3 = store.getState(),
    countries = _store$getState3.countries,
    escStore = _store$getState3.store;
  if (!countries) {
    wrapper.find(config.country).parent().hide();
    return;
  }
  updateFormCountryField(wrapper, countries, escStore.country || "", escStore);
};
var updateFormCountryField = function updateFormCountryField(wrapper, countries, selectedCountryCode, escStore) {
  var countryEl = wrapper.find(config.country);
  countryEl.parent().show().end().html(renderCountries(escStore, countries));
  updateFormDropdownText(wrapper, selectedCountryCode, "country");
};
var getStates = function getStates() {
  var _countries$country;
  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var _store$getState4 = store.getState(),
    countries = _store$getState4.countries,
    escStore = _store$getState4.store;
  if (!country) {
    country = escStore.country;
  }
  return (_countries$country = countries[country]) === null || _countries$country === void 0 ? void 0 : _countries$country.states;
};
var renderFormState = function renderFormState(wrapper) {
  var _payment$address;
  var currentCountry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var resetState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _store$getState5 = store.getState(),
    countries = _store$getState5.countries,
    escStore = _store$getState5.store,
    payment = _store$getState5.payment;
  var country = currentCountry || escStore.country;
  var countryData = countries[country] || [];
  if (showStateField(country, countryData.states || {}) === false) {
    wrapper.find(config.state).parent().hide();
    return;
  }
  var selectedState = resetState === true ? false : ((_payment$address = payment.address) === null || _payment$address === void 0 ? void 0 : _payment$address.state) || "";
  updateFormStateField(wrapper, countryData.states, selectedState, escStore);
};
var showStateField = function showStateField(country, currentCountryStates) {
  var pfasCountryStates = pfasCountries[country] || [];
  return currentCountryStates && pfasCountryStates.length > 0;
};
var extractStateCode = function extractStateCode(data) {
  if (!data || !data.state_code) {
    return null;
  }
  if (data.country_code2 && data.country_code2 == "GB") {
    return data.state_code;
  }
  var parts = data.state_code.split("-");
  if (parts.length <= 1) {
    return data.state_code;
  }
  return parts[1];
};
var getDefaultState = function getDefaultState(states) {
  return new Promise(function (resolve) {
    var defaultState = "";
    getIpInfo().then(function (ipInfo) {
      if (ipInfo && ipInfo.state_code) {
        var stateCode = extractStateCode(ipInfo);
        if (stateCode && states[stateCode] != undefined) {
          defaultState = stateCode;
        }
      }
      resolve(defaultState);
    }).catch(function (err) {
      console.log("error", err);
      resolve(defaultState);
    });
  });
};
var renderCurrentStateText = function renderCurrentStateText(wrapper, currentState) {
  if (wrapper.length === 0 || !currentState) return;
  var stateTextEl = wrapper.find(config.currentStateText);
  if (stateTextEl.length === 0) return;
  stateTextEl.text(currentState);
};
var updateFormStateField = function updateFormStateField(wrapper, states, selectedStateCode, escStore) {
  var stateEl = wrapper.find(config.state);
  var handleUpdate = function handleUpdate(selectedStateCode) {
    stateEl.parent().show().end().html(renderStates(escStore, states, selectedStateCode));
    updateFormDropdownText(wrapper, selectedStateCode, "state");
  };
  if (!selectedStateCode) {
    getDefaultState(states).then(function (defaultState) {
      handleUpdate(defaultState);
    });
  } else {
    handleUpdate(selectedStateCode);
  }
};
var updateFormDropdownText = function updateFormDropdownText(wrapper, selectedValue) {
  var _countries$selectedVa;
  var fieldType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "state";
  var isCountry = fieldType === "country";
  var configText = isCountry ? config.countryText : config.stateText;
  var selectedValueName = isCountry ? ((_countries$selectedVa = countries[selectedValue]) === null || _countries$selectedVa === void 0 ? void 0 : _countries$selectedVa.name) || window.sitewide.chooseCountry : states[selectedValue] || window.sitewide.chooseState;
  wrapper.find(configText).text(selectedValueName);
  if (onPageLoad && fieldType === 'state' && selectedValue) {
    renderCurrentStateText(wrapper, selectedValueName);
  }
};
export default pfasInit;
export { getCookieData, deleteCookieData, extractStateCode, handleCountryChange, removePfasProductFromCart, handleGeoBasedRedirect };


// WEBPACK FOOTER //
// ./scripts/components/pfas.js